import * as i0 from '@angular/core';
import { EventEmitter, Component, Output, Input, ContentChild, PLATFORM_ID, ViewEncapsulation, Inject, NgModule } from '@angular/core';
import { JSReportDesignerBinding } from 'devexpress-reporting/dx-reportdesigner';
import * as ko from 'knockout';
import { _inputConverter, _booleanConverter, DxReportingComponent } from 'devexpress-reporting-angular/core';
import { __decorate } from 'tslib';
import { DxReportViewerProgressBarSettingsComponent, DxReportViewerExportSettingsComponent, DxReportViewerSearchSettingsComponent } from 'devexpress-reporting-angular/dx-report-viewer';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class DxReportDesignerCallbacksComponent {
    CustomizeElements = new EventEmitter();
    ExitDesigner = new EventEmitter();
    ReportSaving = new EventEmitter();
    ReportSaved = new EventEmitter();
    ReportOpened = new EventEmitter();
    ReportOpening = new EventEmitter();
    TabChanged = new EventEmitter();
    ReportTabClosing = new EventEmitter();
    ReportTabClosed = new EventEmitter();
    ComponentAdded = new EventEmitter();
    CustomizeParameterEditors = new EventEmitter();
    CustomizeParameterProperties = new EventEmitter();
    CustomizeSaveDialog = new EventEmitter();
    CustomizeSaveAsDialog = new EventEmitter();
    CustomizeOpenDialog = new EventEmitter();
    CustomizeToolbox = new EventEmitter();
    CustomizeFieldListActions = new EventEmitter();
    CustomizeMenuActions = new EventEmitter();
    CustomizeLocalization = new EventEmitter();
    OnInitializing = new EventEmitter();
    BeforeRender = new EventEmitter();
    OnServerError = new EventEmitter();
    CustomizeWizard = new EventEmitter();
    PreviewClick = new EventEmitter();
    PreviewCustomizeElements = new EventEmitter();
    PreviewCustomizeMenuActions = new EventEmitter();
    PreviewEditingFieldChanged = new EventEmitter();
    PreviewDocumentReady = new EventEmitter();
    PreviewParametersReset = new EventEmitter();
    PreviewCustomizeParameterLookUpSource = new EventEmitter();
    PreviewParametersInitialized = new EventEmitter();
    PreviewCustomizeExportOptions = new EventEmitter();
    PreviewParametersSubmitted = new EventEmitter();
    PreviewOnExport = new EventEmitter();
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerCallbacksComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxReportDesignerCallbacksComponent, selector: "dxrd-callbacks", outputs: { CustomizeElements: "CustomizeElements", ExitDesigner: "ExitDesigner", ReportSaving: "ReportSaving", ReportSaved: "ReportSaved", ReportOpened: "ReportOpened", ReportOpening: "ReportOpening", TabChanged: "TabChanged", ReportTabClosing: "ReportTabClosing", ReportTabClosed: "ReportTabClosed", ComponentAdded: "ComponentAdded", CustomizeParameterEditors: "CustomizeParameterEditors", CustomizeParameterProperties: "CustomizeParameterProperties", CustomizeSaveDialog: "CustomizeSaveDialog", CustomizeSaveAsDialog: "CustomizeSaveAsDialog", CustomizeOpenDialog: "CustomizeOpenDialog", CustomizeToolbox: "CustomizeToolbox", CustomizeFieldListActions: "CustomizeFieldListActions", CustomizeMenuActions: "CustomizeMenuActions", CustomizeLocalization: "CustomizeLocalization", OnInitializing: "OnInitializing", BeforeRender: "BeforeRender", OnServerError: "OnServerError", CustomizeWizard: "CustomizeWizard", PreviewClick: "PreviewClick", PreviewCustomizeElements: "PreviewCustomizeElements", PreviewCustomizeMenuActions: "PreviewCustomizeMenuActions", PreviewEditingFieldChanged: "PreviewEditingFieldChanged", PreviewDocumentReady: "PreviewDocumentReady", PreviewParametersReset: "PreviewParametersReset", PreviewCustomizeParameterLookUpSource: "PreviewCustomizeParameterLookUpSource", PreviewParametersInitialized: "PreviewParametersInitialized", PreviewCustomizeExportOptions: "PreviewCustomizeExportOptions", PreviewParametersSubmitted: "PreviewParametersSubmitted", PreviewOnExport: "PreviewOnExport" }, ngImport: i0, template: '', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerCallbacksComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrd-callbacks'
                }]
        }], propDecorators: { CustomizeElements: [{
                type: Output
            }], ExitDesigner: [{
                type: Output
            }], ReportSaving: [{
                type: Output
            }], ReportSaved: [{
                type: Output
            }], ReportOpened: [{
                type: Output
            }], ReportOpening: [{
                type: Output
            }], TabChanged: [{
                type: Output
            }], ReportTabClosing: [{
                type: Output
            }], ReportTabClosed: [{
                type: Output
            }], ComponentAdded: [{
                type: Output
            }], CustomizeParameterEditors: [{
                type: Output
            }], CustomizeParameterProperties: [{
                type: Output
            }], CustomizeSaveDialog: [{
                type: Output
            }], CustomizeSaveAsDialog: [{
                type: Output
            }], CustomizeOpenDialog: [{
                type: Output
            }], CustomizeToolbox: [{
                type: Output
            }], CustomizeFieldListActions: [{
                type: Output
            }], CustomizeMenuActions: [{
                type: Output
            }], CustomizeLocalization: [{
                type: Output
            }], OnInitializing: [{
                type: Output
            }], BeforeRender: [{
                type: Output
            }], OnServerError: [{
                type: Output
            }], CustomizeWizard: [{
                type: Output
            }], PreviewClick: [{
                type: Output
            }], PreviewCustomizeElements: [{
                type: Output
            }], PreviewCustomizeMenuActions: [{
                type: Output
            }], PreviewEditingFieldChanged: [{
                type: Output
            }], PreviewDocumentReady: [{
                type: Output
            }], PreviewParametersReset: [{
                type: Output
            }], PreviewCustomizeParameterLookUpSource: [{
                type: Output
            }], PreviewParametersInitialized: [{
                type: Output
            }], PreviewCustomizeExportOptions: [{
                type: Output
            }], PreviewParametersSubmitted: [{
                type: Output
            }], PreviewOnExport: [{
                type: Output
            }] } });

class DxReportDesignerDataSourceSettingsComponent {
    allowAddDataSource;
    allowRemoveDataSource;
    allowEditDataSource;
    getSerializableSettings() {
        return {
            allowAddDataSource: this.allowAddDataSource,
            allowRemoveDataSource: this.allowRemoveDataSource,
            allowEditDataSource: this.allowEditDataSource
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerDataSourceSettingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxReportDesignerDataSourceSettingsComponent, selector: "dxrd-datasource-settings", inputs: { allowAddDataSource: "allowAddDataSource", allowRemoveDataSource: "allowRemoveDataSource", allowEditDataSource: "allowEditDataSource" }, ngImport: i0, template: '', isInline: true });
}
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerDataSourceSettingsComponent.prototype, "allowAddDataSource", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerDataSourceSettingsComponent.prototype, "allowRemoveDataSource", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerDataSourceSettingsComponent.prototype, "allowEditDataSource", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerDataSourceSettingsComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrd-datasource-settings'
                }]
        }], propDecorators: { allowAddDataSource: [{
                type: Input
            }], allowRemoveDataSource: [{
                type: Input
            }], allowEditDataSource: [{
                type: Input
            }] } });

class DxReportDesignerPreviewSettingsComponent {
    porgressbarSettings;
    exportSettings;
    searchSettings;
    getSerializableSettings() {
        return {
            exportSettings: this.exportSettings?.getSerializableSettings(),
            progressBarSettings: this.porgressbarSettings?.getSerializableSettings(),
            searchSettings: this.searchSettings?.getSerializableSettings()
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerPreviewSettingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxReportDesignerPreviewSettingsComponent, selector: "dxrd-preview-settings", queries: [{ propertyName: "porgressbarSettings", first: true, predicate: DxReportViewerProgressBarSettingsComponent, descendants: true }, { propertyName: "exportSettings", first: true, predicate: DxReportViewerExportSettingsComponent, descendants: true }, { propertyName: "searchSettings", first: true, predicate: DxReportViewerSearchSettingsComponent, descendants: true }], ngImport: i0, template: '', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerPreviewSettingsComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrd-preview-settings'
                }]
        }], propDecorators: { porgressbarSettings: [{
                type: ContentChild,
                args: [DxReportViewerProgressBarSettingsComponent]
            }], exportSettings: [{
                type: ContentChild,
                args: [DxReportViewerExportSettingsComponent]
            }], searchSettings: [{
                type: ContentChild,
                args: [DxReportViewerSearchSettingsComponent]
            }] } });

class DxReportDesignerWizardSettingsComponent {
    useMasterDetailWizard;
    enableJsonDataSource;
    enableSqlDataSource;
    enableObjectDataSource;
    enableFederationDataSource;
    useFullscreenWizard;
    reportWizardTemplatesSearchBoxVisibility;
    getSerializableSettings() {
        return {
            useMasterDetailWizard: this.useMasterDetailWizard,
            enableJsonDataSource: this.enableJsonDataSource,
            enableSqlDataSource: this.enableSqlDataSource,
            enableObjectDataSource: this.enableObjectDataSource,
            enableFederationDataSource: this.enableFederationDataSource,
            useFullscreenWizard: this.useFullscreenWizard,
            reportWizardTemplatesSearchBoxVisibility: this.reportWizardTemplatesSearchBoxVisibility
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerWizardSettingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxReportDesignerWizardSettingsComponent, selector: "dxrd-wizard-settings", inputs: { useMasterDetailWizard: "useMasterDetailWizard", enableJsonDataSource: "enableJsonDataSource", enableSqlDataSource: "enableSqlDataSource", enableObjectDataSource: "enableObjectDataSource", enableFederationDataSource: "enableFederationDataSource", useFullscreenWizard: "useFullscreenWizard", reportWizardTemplatesSearchBoxVisibility: "reportWizardTemplatesSearchBoxVisibility" }, ngImport: i0, template: '', isInline: true });
}
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerWizardSettingsComponent.prototype, "useMasterDetailWizard", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerWizardSettingsComponent.prototype, "enableJsonDataSource", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerWizardSettingsComponent.prototype, "enableSqlDataSource", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerWizardSettingsComponent.prototype, "enableObjectDataSource", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerWizardSettingsComponent.prototype, "enableFederationDataSource", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerWizardSettingsComponent.prototype, "useFullscreenWizard", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerWizardSettingsComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrd-wizard-settings'
                }]
        }], propDecorators: { useMasterDetailWizard: [{
                type: Input
            }], enableJsonDataSource: [{
                type: Input
            }], enableSqlDataSource: [{
                type: Input
            }], enableObjectDataSource: [{
                type: Input
            }], enableFederationDataSource: [{
                type: Input
            }], useFullscreenWizard: [{
                type: Input
            }], reportWizardTemplatesSearchBoxVisibility: [{
                type: Input
            }] } });

class DxReportDesignerParameterEditingSettingsComponent {
    allowReorderParameters;
    allowEditParameterCollection;
    allowEditProperties;
    allowEditParameterGroups;
    allowEditParameterSeparators;
    getSerializableSettings() {
        return {
            allowReorderParameters: this.allowReorderParameters,
            allowEditParameterCollection: this.allowEditParameterCollection,
            allowEditProperties: this.allowEditProperties,
            allowEditParameterGroups: this.allowEditParameterGroups,
            allowEditParameterSeparators: this.allowEditParameterSeparators
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerParameterEditingSettingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxReportDesignerParameterEditingSettingsComponent, selector: "dxrd-parameter-editing-settings", inputs: { allowReorderParameters: "allowReorderParameters", allowEditParameterCollection: "allowEditParameterCollection", allowEditProperties: "allowEditProperties", allowEditParameterGroups: "allowEditParameterGroups", allowEditParameterSeparators: "allowEditParameterSeparators" }, ngImport: i0, template: '', isInline: true });
}
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerParameterEditingSettingsComponent.prototype, "allowReorderParameters", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerParameterEditingSettingsComponent.prototype, "allowEditParameterCollection", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerParameterEditingSettingsComponent.prototype, "allowEditProperties", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerParameterEditingSettingsComponent.prototype, "allowEditParameterGroups", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerParameterEditingSettingsComponent.prototype, "allowEditParameterSeparators", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerParameterEditingSettingsComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrd-parameter-editing-settings'
                }]
        }], propDecorators: { allowReorderParameters: [{
                type: Input
            }], allowEditParameterCollection: [{
                type: Input
            }], allowEditProperties: [{
                type: Input
            }], allowEditParameterGroups: [{
                type: Input
            }], allowEditParameterSeparators: [{
                type: Input
            }] } });

class DxReportDesignerModelSettingsComponent {
    allowMDI;
    rightToLeft;
    previewSettings;
    wizardSettings;
    dataSourceSettings;
    parameterEditingSettings;
    getSerializableSettings() {
        return {
            reportPreviewSettings: this.previewSettings?.getSerializableSettings(),
            wizardSettings: this.wizardSettings?.getSerializableSettings(),
            dataSourceSettings: this.dataSourceSettings?.getSerializableSettings(),
            parameterEditingSettings: this.parameterEditingSettings?.getSerializableSettings(),
            allowMDI: this.allowMDI,
            rightToLeft: this.rightToLeft
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerModelSettingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxReportDesignerModelSettingsComponent, selector: "dxrd-designer-model-settings", inputs: { allowMDI: "allowMDI", rightToLeft: "rightToLeft" }, queries: [{ propertyName: "previewSettings", first: true, predicate: DxReportDesignerPreviewSettingsComponent, descendants: true }, { propertyName: "wizardSettings", first: true, predicate: DxReportDesignerWizardSettingsComponent, descendants: true }, { propertyName: "dataSourceSettings", first: true, predicate: DxReportDesignerDataSourceSettingsComponent, descendants: true }, { propertyName: "parameterEditingSettings", first: true, predicate: DxReportDesignerParameterEditingSettingsComponent, descendants: true }], ngImport: i0, template: '', isInline: true });
}
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerModelSettingsComponent.prototype, "allowMDI", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportDesignerModelSettingsComponent.prototype, "rightToLeft", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerModelSettingsComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrd-designer-model-settings'
                }]
        }], propDecorators: { allowMDI: [{
                type: Input
            }], rightToLeft: [{
                type: Input
            }], previewSettings: [{
                type: ContentChild,
                args: [DxReportDesignerPreviewSettingsComponent]
            }], wizardSettings: [{
                type: ContentChild,
                args: [DxReportDesignerWizardSettingsComponent]
            }], dataSourceSettings: [{
                type: ContentChild,
                args: [DxReportDesignerDataSourceSettingsComponent]
            }], parameterEditingSettings: [{
                type: ContentChild,
                args: [DxReportDesignerParameterEditingSettingsComponent]
            }] } });

class DxReportDesignerRequestOptionsComponent {
    getDesignerModelAction;
    getLocalizationAction;
    host;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerRequestOptionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxReportDesignerRequestOptionsComponent, selector: "dxrd-request-options", inputs: { getDesignerModelAction: "getDesignerModelAction", getLocalizationAction: "getLocalizationAction", host: "host" }, ngImport: i0, template: '', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerRequestOptionsComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrd-request-options'
                }]
        }], propDecorators: { getDesignerModelAction: [{
                type: Input
            }], getLocalizationAction: [{
                type: Input
            }], host: [{
                type: Input
            }] } });

class DxReportDesignerComponent extends DxReportingComponent {
    koReportUrl = ko.observable();
    bindingSender;
    requestOptions;
    callbacksComponent;
    designerModelSettings;
    constructor(renderer, platformId) {
        super(renderer, platformId);
    }
    getCallbacks() {
        return this.callbacksComponent;
    }
    getKoBinding(options) {
        return new JSReportDesignerBinding(options, this.getEventRaiser());
    }
    getControlOptions() {
        return {
            developmentMode: this.developmentMode,
            reportUrl: this.koReportUrl,
            requestOptions: this.requestOptions,
            designerModelSettings: this.designerModelSettings?.getSerializableSettings(),
            callbacks: { designer: {}, preview: {} }
        };
    }
    ngOnDestroy() {
        ko.cleanNode(this.control.nativeElement);
        super.ngOnDestroy();
        this.requestOptions = null;
        this.callbacksComponent = null;
        this.koReportUrl = null;
        this.designerModelSettings = null;
    }
    GetDesignerModel() {
        return this.bindingSender.GetDesignerModel();
    }
    GetPreviewModel() {
        return this.bindingSender.GetPreviewModel();
    }
    get reportUrl() {
        return this.koReportUrl();
    }
    set reportUrl(reportUrl) {
        this.koReportUrl(reportUrl);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerComponent, deps: [{ token: i0.Renderer2 }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxReportDesignerComponent, selector: "dx-report-designer", inputs: { reportUrl: "reportUrl" }, queries: [{ propertyName: "requestOptions", first: true, predicate: DxReportDesignerRequestOptionsComponent, descendants: true }, { propertyName: "callbacksComponent", first: true, predicate: DxReportDesignerCallbacksComponent, descendants: true }, { propertyName: "designerModelSettings", first: true, predicate: DxReportDesignerModelSettingsComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "<div #control [ngClass]=\"cssClass\" [ngStyle]=\"{'width': width, 'height': height }\">\n  <div data-bind=\"dxReportDesigner: $data\"></div>\n</div>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dx-report-designer', encapsulation: ViewEncapsulation.None, template: "<div #control [ngClass]=\"cssClass\" [ngStyle]=\"{'width': width, 'height': height }\">\n  <div data-bind=\"dxReportDesigner: $data\"></div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { requestOptions: [{
                type: ContentChild,
                args: [DxReportDesignerRequestOptionsComponent]
            }], callbacksComponent: [{
                type: ContentChild,
                args: [DxReportDesignerCallbacksComponent]
            }], designerModelSettings: [{
                type: ContentChild,
                args: [DxReportDesignerModelSettingsComponent]
            }], reportUrl: [{
                type: Input
            }] } });

class DxReportDesignerModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerModule, declarations: [DxReportDesignerCallbacksComponent,
            DxReportDesignerRequestOptionsComponent,
            DxReportDesignerComponent,
            DxReportDesignerPreviewSettingsComponent,
            DxReportDesignerWizardSettingsComponent,
            DxReportDesignerDataSourceSettingsComponent,
            DxReportDesignerParameterEditingSettingsComponent,
            DxReportDesignerModelSettingsComponent], imports: [CommonModule], exports: [DxReportDesignerCallbacksComponent,
            DxReportDesignerRequestOptionsComponent,
            DxReportDesignerComponent,
            DxReportDesignerPreviewSettingsComponent,
            DxReportDesignerWizardSettingsComponent,
            DxReportDesignerDataSourceSettingsComponent,
            DxReportDesignerParameterEditingSettingsComponent,
            DxReportDesignerModelSettingsComponent], id: 'DxReportDesignerModule' });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxReportDesignerModule, decorators: [{
            type: NgModule,
            args: [{
                    id: 'DxReportDesignerModule',
                    imports: [CommonModule],
                    declarations: [
                        DxReportDesignerCallbacksComponent,
                        DxReportDesignerRequestOptionsComponent,
                        DxReportDesignerComponent,
                        DxReportDesignerPreviewSettingsComponent,
                        DxReportDesignerWizardSettingsComponent,
                        DxReportDesignerDataSourceSettingsComponent,
                        DxReportDesignerParameterEditingSettingsComponent,
                        DxReportDesignerModelSettingsComponent
                    ],
                    exports: [
                        DxReportDesignerCallbacksComponent,
                        DxReportDesignerRequestOptionsComponent,
                        DxReportDesignerComponent,
                        DxReportDesignerPreviewSettingsComponent,
                        DxReportDesignerWizardSettingsComponent,
                        DxReportDesignerDataSourceSettingsComponent,
                        DxReportDesignerParameterEditingSettingsComponent,
                        DxReportDesignerModelSettingsComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of reporting-angular/report-designer
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxReportDesignerCallbacksComponent, DxReportDesignerComponent, DxReportDesignerDataSourceSettingsComponent, DxReportDesignerModelSettingsComponent, DxReportDesignerModule, DxReportDesignerParameterEditingSettingsComponent, DxReportDesignerPreviewSettingsComponent, DxReportDesignerRequestOptionsComponent, DxReportDesignerWizardSettingsComponent };
